import styles from './AWSFargate.module.scss'
import Contact from '../pages/Contact'
import BestPractice from '../pages/BestPractice'
import Features from '../pages/Features'
import Introduction from '../pages/Introduction'
import Top from '../pages/Top'
import Flow from '../pages/Flow'
import PriceList from '../pages/PriceList'
import QA from '../pages/QA'
import CallToAction from '../pages/CallToAction'
import Architecture from '../pages/Architecture'
import { useRef } from 'react'
import useScrollHideContact from '../hooks/useScrollHideContact'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import NewsLp from '../pages/NewsLp'

const ContactFormId = '59e207f0-951b-4891-b6c3-5b1d14386190'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '/services' },
  { name: 'AWS Fargate', url: '#' },
]

const TopContents = {
  smallTitle: 'サーバー管理の負担から解放',
  title: ['AWS Fargateで実現する', 'サーバーレスコンテナ環境'],
  text: 'インフラ管理から解放され、アプリケーション開発に集中できる環境を提供します。',
  imgLink: '/images/LP/LP202407/Logo/LogoAWSFargate.png',
}

const IntroductionContents = {
  title: 'コンテナ運用の複雑さに、こんな悩みはありませんか？',
  list: [
    {
      text: ['サーバー管理やスケーリングの負担が大きく、本来の開発業務に集中できない'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsServer.svg',
    },
    {
      text: ['コンテナのセキュリティ管理や運用が複雑で、専門知識が必要'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsFileLock2.svg',
    },
    {
      text: ['インフラコストの最適化が難しく、リソースの無駄が生じている'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsGraphDown.svg',
    },
  ],
}
const BestPracticeContents = {
  heading: ['コンテナ技術の利点を最大限に活用し、', '管理の手間を最小限に抑えます'],
  text: [
    'AWS Fargate導入支援サービスは、コンテナ技術の革新的な利点を活用しつつ、その管理の複雑さから解放されたい企業に最適です。',
    'クラウドネイティブな開発環境で迅速なデプロイを実現し、必要に応じて瞬時にスケールアップが可能。リソースの無駄を省きながら、ビジネスの成長に合わせた柔軟な運用を可能にします。',
    '私たちの専門家チームが、お客さまのニーズに合わせた最適なFargate環境の設計から運用までをトータルでサポートします。',
  ],
}

const ArchitectureContents = {
  title: 'AWS Fargate',
  imgLink: ['/images/LP/LP202407/Architectures/architecture-awsfargate.png'],
}

const FeaturesContents = {
  title: 'AWS Fargate',
  items: [
    {
      num: '01',
      itemTitle: 'サーバーレスコンテナ環境の実現',
      description:
        'AWS Fargateにより、サーバーのプロビジョニングや管理が不要になります。当社の専門家チームが、お客さまの要件に最適化されたFargate環境を設計・構築し、開発チームがアプリケーション開発に集中できる環境を提供します。',
      src: '/images/LP/LP202407/img/img03.jpeg',
    },
    {
      num: '02',
      itemTitle: '自動スケーリングの最適化',
      description:
        'トラフィックの変動に応じて自動でスケールするFargateの特性を最大限に活かします。お客さまのビジネスニーズに合わせたスケーリング戦略を策定し、効率的なリソース管理とコスト最適化を実現します。',
      src: '/images/LP/LP202407/img/img04.jpeg',
    },
    {
      num: '03',
      itemTitle: 'セキュアで高性能なコンテナ実行環境の構築',
      description:
        'AWS Fargateの強力なセキュリティ機能を活用し、コンテナごとに隔離された環境を提供します。AWSの認定資格を持つエンジニアが、最新のセキュリティベストプラクティスに基づいた高性能かつ安全な実行環境を構築し、継続的な監視と改善を行います。',
      src: '/images/LP/LP202407/img/img02.jpeg',
    },
  ],
}

const FlowContents = [
  {
    num: 1,
    title: '現状分析',
    description: 'お客さまの開発環境と課題を詳細に分析します。',
    src: '/images/LP/LP202407/Icon/BsBarChartLine.svg',
  },
  {
    num: 2,
    title: '最適化プラン策定',
    description: 'AWS Fargateを活用した最適な開発環境を設計します。',
    src: '/images/LP/LP202407/Icon/BsDiagram3.svg',
  },
  {
    num: 3,
    title: '環境構築',
    description: 'サーバーレスコンテナ環境を構築し、既存アプリケーションの移行をサポートします。',
    src: '/images/LP/LP202407/Icon/BsPersonCheck.svg',
  },
]

const FAQContents = [
  {
    num: 1,
    question: 'AWS Fargateを導入すると、どのように開発の生産性が向上しますか？',
    answer:
      'サーバー管理やスケーリングの負担が軽減されるため、開発者は本来の開発業務に集中できます。また、環境のセットアップが迅速になり、新しいアイデアの実装や検証が素早く行えるようになります。',
  },
  {
    num: 2,
    question: '既存のアプリケーションをFargateに移行するのは難しいですか？',
    answer:
      '当社の専門家チームが、スムーズな移行をサポートします。既存のコンテナ化されたアプリケーションは比較的容易に移行でき、従来のアプリケーションもコンテナ化のサポートを提供します。移行の複雑さに関わらず、段階的なアプローチで確実に移行を完了させます。',
  },
  {
    num: 3,
    question: 'Fargateを導入することで、具体的にどの程度のコスト削減が見込めますか？',
    answer:
      '使用したリソースに対してのみ課金されるため、多くの場合で20-40%程度のコスト削減が可能です。ただし、具体的な削減額は現在の環境やワークロードによって異なります。お客さまの環境を詳細に分析し、最適なコスト削減プランを提案します。',
  },
  {
    num: 4,
    question: 'AWS FargateとAmazon EC2の違いは何ですか？どのように選べばよいでしょうか？',
    answer:
      'Fargateはサーバーレスであり、インフラストラクチャの管理が不要な一方、EC2では仮想マシンのプロビジョニングと管理が必要です。Fargateは管理やスケーラビリティの簡易化が魅力的です。お客さまのニーズや既存のインフラ環境を考慮し、最適な選択をサポートします。',
  },
  {
    num: 5,
    question: 'AitriaのAWS Fargate導入支援サービスの特徴は何ですか？',
    answer:
      '当社の特徴は、AWS認定資格を持つ専門家による手厚いサポート、豊富な導入実績に基づく知見、お客さまのビジネスニーズに合わせたカスタマイズ能力です。また、継続的な最適化提案により、導入後も安心してご利用いただけます。Fargateの利点を最大限に引き出し、お客さまのビジネス成長を加速させます。',
  },
]

const inPocketList = [
  {
    image: '/images/inPocket/AWS Fargate/story_AWSFargate.png',
    title: 'AWS AIで生成する物語-第5話：インフラ管理の簡素化のカギとなるAWS Fargateに出会う話',
    date: '2024.10.24',
    href: 'https://aitria.co.jp/in-pocket/12294',
  },
  {
    image: '/images/inPocket/AWS Fargate/knowledge_AWSfargate.png',
    title: 'AWS Fargateとは？クラウドネイティブな開発を実現するサーバーレスコンテナサービス',
    date: '2024.9.10',
    href: 'https://aitria.co.jp/in-pocket/11706',
  },
  {
    image: '/images/inPocket/AWS Fargate/devops_toolchain.png',
    title: 'DevOpsツールチェーンとは？基本からツール選定のプロセス・注意点を解説',
    date: '2024.8.13',
    href: 'https://aitria.co.jp/in-pocket/11334',
  },
]

const topics = [
  {
    title:
      '特徴量エンジニアリングを使って生成AIによるUIデザインと画面レイアウトのアウトプットをコントロールする技術を開発',
    date: '2024年9月6日',
    src: '/pressrelease/3726',
  },
  {
    title: 'アート引越センターが提供する、AIが自動見積りをするアプリの開発支援をいたしました',
    date: '2024年5月21日',
    src: '/pressrelease/3369',
  },
  { title: 'AWSセレクトティアサービスパートナーに認定', date: '2023年5月29日', src: '/pressrelease/2785' },
]

const CallToActionContents = {
  heading: ['今すぐAWS Fargateを導入し、', '開発効率を劇的に向上させましょう'],
}

const AWSFargate: React.FC = () => {
  const contactRef = useRef<HTMLDivElement>(null)
  const contentsRef = useRef<HTMLDivElement>(null)

  useScrollHideContact(contactRef, contentsRef)
  return (
    <>
      <article className={styles.LPPage}>
        <div className={styles.contents} ref={contentsRef}>
          <Top contents={TopContents} paths={paths} />
          <Introduction contents={IntroductionContents} />
          <BestPractice contents={BestPracticeContents} />
          <Architecture contents={ArchitectureContents} />
          <Features contents={FeaturesContents} />
          <Flow contents={FlowContents} />
          <PriceList />
          <QA contents={FAQContents} />
          <NewsLp inPocketList={inPocketList} topics={topics} />
          <CallToAction contents={CallToActionContents} />
        </div>
        <div ref={contactRef} className={styles.contact_wrapper}>
          <Contact formId={ContactFormId} />
        </div>
        <div>
          <MailmagazineLink />
        </div>
      </article>
    </>
  )
}
export default AWSFargate
